import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./Components.module.css";
import { FaChevronDown } from "react-icons/fa6";
import solanaLogo from "../assets/solana-logo.png";
import ethereumLogo from "../assets/ethereum-logo.png";
import polygonLogo from "../assets/polygon-logo.png";
import apis from "../services";
import { Link } from "react-router-dom";
import { FaFlask } from "react-icons/fa";
import { FaArrowTrendUp } from "react-icons/fa6";
import { GoAlertFill } from "react-icons/go";
import { FiAlertTriangle } from "react-icons/fi";
import Header from "./Header";
import DynamicHeader from "../Header/DynamicHeader";

const Filter = ({ setFilters, fetchCards, loading }) => {
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const scrollToTopGainers = () => {
    const topGainersHeading = document.getElementById("topGainersHeading");
    if (topGainersHeading) {
      topGainersHeading.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div>
      <div className="home-header-sticky">
        <DynamicHeader />
        {/* <Header showHeader={true} /> */}
      </div>

      <div className="invest-top">
        <div className="invest-top-bottom">
          <div className="polygon">
            <Link to="/check-scam">
              <button className="btn-gainer-slash-slash">
                {" "}
                <img />
                <FiAlertTriangle
                  style={{ width: "40px", height: "40px", color: "red" }}
                />
                Check Scammer Identifier
              </button>
            </Link>
          </div>

          <div className="ethereum">
            <button className="btn-gainer-slash" onClick={scrollToTopGainers}>
              <FaFlask color="#a3e635" />
              New Pools
            </button>
          </div>
          <div className="ethereum">
            <button className="btn-gainer-slash" onClick={scrollToTopGainers}>
              {" "}
              <FaArrowTrendUp color="#a3e635" />
              Top Gainers
            </button>
          </div>

          <div>
            <select
              name="chainName"
              className="invest-top-bottom-select"
              onChange={handleFilterChange}
            >
              <option defaultValue={"all"}>All</option>
              <option value={"eth"}>Ethereum</option>
              <option value={"solana"}>Solana</option>
              <option value={"bsc"}>Binance</option>
              <option value={"avax"}>Avalanche</option>
              <option value={"polygon_pos"}>Polygon</option>
            </select>
          </div>
        </div>
      </div>

      {/* Filter Section */}
      <div className={styles.filterMain}>
        <div className={styles.filterChild}>
          <div className={styles.filterContainer}>
            <div className={styles.filterHeader}>
              <FaChevronDown className={styles.filterIcon} />
              <span>Advanced Filters</span>
            </div>

            <div className={styles.filtersGrid}>
              {/* Static Filters */}
              <div className={styles.filterGroup}>
                <label className={styles.filterLabel}>Age</label>
                <select
                  className={styles.select}
                  defaultValue="all"
                  name="age"
                  onChange={handleFilterChange}
                >
                  <option value="">All</option>
                  <option value="0-1hr">0-1hr</option>
                  <option value="1hr-24hr">1hr-24hr</option>
                  <option value="1 week">1 week</option>
                  <option value="1 month">1 month</option>
                </select>
              </div>
              <div className={styles.filterGroup}>
                <label className={styles.filterLabel}>Score</label>
                <select
                  className={styles.select}
                  defaultValue="all"
                  name="score"
                  onChange={handleFilterChange}
                >
                  <option value="">All</option>
                  <option value="greater than 70">greater than 70</option>
                  <option value="less than 60">less than 60</option>
                  <option value="greater than 80">greater than 80</option>
                </select>
              </div>
              <div className={styles.filterGroup}>
                <label className={styles.filterLabel}>Liquidity</label>
                <select
                  className={styles.select}
                  defaultValue="all"
                  name="liquidity"
                  onChange={handleFilterChange}
                >
                  <option value="">All</option>
                  <option value="10-100k">10k-100k</option>
                  <option value="100k-500k">100k-500k</option>
                  <option value="500k-1M">500k-1M</option>
                  <option value="greater than 1M">greater than 1M</option>
                </select>
              </div>
              <div className={styles.filterGroup}>
                <label className={styles.filterLabel}>Volume</label>
                <select
                  className={styles.select}
                  defaultValue="all"
                  name="volume"
                  onChange={handleFilterChange}
                >
                  <option value="">All</option>
                  <option value="10-100k">10-100k</option>
                  <option value="100k-500k">100k-500k</option>
                  <option value="500k-1M">500k-1M</option>
                  <option value="greater than 1M">greater than 1M</option>
                </select>
              </div>

              {/* Start Button */}
              <div className={styles.filterGroup}>
                <button
                  className={styles.filterButton}
                  onClick={fetchCards}
                  disabled={loading}
                >
                  {loading ? "Searching..." : "Search"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <ToastContainer /> */}
    </div>
  );
};

export default Filter;
